<template>
    <MainLayout>
        <div v-if="dataset.page" class="dataset-page">
            <section
                class="dataset-page__hero dataset-hero"
                :class="`dataset-hero--${dataset.color}`"
            >
                <div class="container dataset-hero__container">
                    <div class="dataset-hero__text">
                        <h2 class="dataset-hero__title">
                            {{ dataset.page.title }}
                        </h2>
                        <p class="dataset-hero__description">
                            {{ dataset.page.description }}
                        </p>
                    </div>
                    <div class="dataset-hero__image">
                        <img
                            :src="dataset.page.iconUrl"
                            :alt="dataset.page.title"
                        />
                    </div>
                </div>
            </section>

            <section class="dataset-page__section dataset-section">
                <div class="container dataset-section__container">
                    <div class="dataset-section__text dataset-section-text">
                        <h3 class="dataset-section-text__title">
                            {{ dataset.page.listTitle }}
                        </h3>

                        <ul class="dataset-section-text__list">
                            <li
                                v-for="item in dataset.page.list"
                                :key="item.boldText"
                            >
                                <strong>{{ item.boldText }}</strong>
                                {{ item.text }}
                            </li>
                        </ul>
                    </div>

                    <div class="dataset-section__aside dataset-aside">
                        <div class="dataset-aside__logo">
                            <img
                                src="../assets/images/logo.svg"
                                alt="Dataset Sample"
                            />
                        </div>
                        <div ref="result" class="dataset-section__result"></div>
                        <form
                            ref="datasetForm"
                            action=""
                            class="dataset-section__form form-dataset"
                            @submit.prevent="onSubmit"
                        >
                            <div class="dataset-aside__description">
                                Reqet a demo of Dataset get free consultatiion
                            </div>
                            <v-text-field
                                v-model="model.email"
                                v-validate="{ required: true, email: true }"
                                name="email"
                                prepend-inner-icon="mail"
                                :label="$t('fields.email')"
                                type="email"
                                :data-vv-as="$t('fields.email')"
                                :error-messages="errors.collect('email')"
                                outlined
                            />
                            <div class="form-dataset__row form-row">
                                <button
                                    ref="submitBtn"
                                    type="submit"
                                    class="form-row__submit"
                                >
                                    Request a dataset sample
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>

            <section
                v-for="text in dataset.page.texts"
                :key="`${text.title}_${text.title}`"
                class="dataset-page__text dataset-text"
            >
                <div class="container dataset-text__container">
                    <h3 class="dataset-text__title">
                        {{ text.title }}
                    </h3>
                    <div class="dataset-text__text" v-html="text.inner"></div>
                </div>
            </section>

            <div class="dataset-page__text dataset-text">
                <div class="container dataset-text__container">
                    <h3 class="dataset-text__title">Related Datasets</h3>
                    <ul class="dataset-text__links dataset-text-links">
                        <template v-for="service in Services">
                            <li
                                v-if="service.id !== dataset.id"
                                :key="service.title"
                                class="dataset-text-links__item"
                            >
                                <router-link
                                    class="dataset-text-link"
                                    :class="`dataset-text-link--${service.color}`"
                                    :to="service.id"
                                    >{{ service.link }}</router-link
                                >
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </MainLayout>
</template>

<script>
    import MainLayout from '../layouts/MainLayout.vue';
    import Services from '@/constants/services';
    import { general } from '~api';
    import { Handler } from '~services';

    export default {
        $_veeValidate: {
            validator: 'new',
        },
        components: {
            MainLayout,
        },
        data() {
            return {
                dataset: '',
                Services,
                model: {
                    email: '',
                    message: '',
                    name: '',
                },
            };
        },
        mounted() {
            this.dataset = Services[this.$route.params.id];
            if (!this.dataset) this.$router.push('/');
        },
        updated() {
            this.dataset = Services[this.$route.params.id];
        },
        methods: {
            /**
             * Request data methos
             */
            async onSubmit() {
                this.isLoading = true;

                const validation = await this.$validator.validateAll();
                if (!validation) return;

                const data = new FormData();
                data.append('email', this.model.email);
                data.append('name', 'Anonymous');
                data.append(
                    'message',
                    `Request for sample ${this.$route.params.id} dataset`
                );

                const resp = await general.contact(data);

                Handler.handleResponse(resp, resp.data, resp.data);

                this.isLoading = false;
            },
        },
    };
</script>

<style scoped lang="stylus">
    @import '../assets/styles/pages/dataset';
</style>
